<template>
  <div class="pt-20">
    <!--Header-->

    <div class="header bg-black">
      <div class="header-body" style="max-width: 2200px; margin: auto">
        <div class="flex justify-center items-stretch">
          <div class="flex-1 relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-1.jpg)"
            ></div>
          </div>
          <div class="header-letter flex items-center justify-center relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-4.jpg)"
            ></div>
            <div class="relative">V</div>
          </div>
          <div class="header-letter flex items-center justify-center relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-2.jpg)"
            ></div>
            <div class="relative">I</div>
          </div>
          <div class="header-letter flex items-center justify-center relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-3.jpg)"
            ></div>
            <div class="relative">V</div>
          </div>
          <div class="header-letter flex items-center justify-center relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-6.jpg)"
            ></div>
            <div class="relative">A</div>
          </div>
          <div class="flex-1 relative">
            <div
              class="absolute inset-0 bg-cover bg-center opacity-75 bg-blue-200 header-bg"
              style="background-image: url(./img/brand/header-5.jpg)"
            ></div>
          </div>
        </div>
      </div>

      <!-- <div class="hidden md:block separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div> -->
    </div>

    <!-- Page content -->
    <section class="pt-32 pb-48 viva-blue px-2">
      <div class="flex justify-center text-center">
        <div class="w-full px-2 md:px-0 md:w-2/3">
          <h2 class="display-3 text-4xl flex justify-center leading-10 font-semibold text-white">
            Financial Wellness for Employees
          </h2>

          <p class="lead text-base md:text-xl mt-6 text-blue-100">
            VIVA improves employees' financial well-being through its affordable lending program and
            financial education resources.
          </p>
        </div>
      </div>
    </section>

    <section class="section section-lg pt-lg-0 -m-32"></section>
    <div class="flex flex-wrap justify-center md:flex-no-wrap px-2 md:px-56 gap-6">
      <div>
        <div class="card-shadow dashboard-card border-0 text-center px-5 max-w-430">
          <div class="card-body pt-5">
            <div class="flex flex-col items-center justify-center mb-2">
              <div class="icon icon-shape viva-blue-text text-xl mb-3">
                <i class="fas fa-hand-holding-usd text-danger"></i>
              </div>
              <h3 class="h3 my-3">Apply For a Loan Today</h3>
            </div>
            <p class="px-2 description my-3">
              VIVA's salary-linked loans help employees to manage unexpected expenses and build
              credit.
            </p>
            <div class="">
              <base-button
                @click="$emit('applies', true)"
                aria-label="apply"
                type="primary px-3 text-sm mt-4 w-full"
              >
                Apply For a Loan
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card-shadow dashboard-card border-0 text-center px-5 max-w-430">
          <div class="card-body pt-5">
            <div class="flex flex-col items-center justify-center mb-2">
              <div class="icon icon-shape viva-blue-text text-xl mb-3">
                <i class="fas fa-graduation-cap text-danger"></i>
              </div>
              <h3 class="h3 my-3">Financial Coaching and Education</h3>
            </div>
            <p class="px-2 description my-3">
              VIVA’s financial education tools are here to help you grow your savings and achieve
              financial freedom.
            </p>
            <div>
              <base-button
                @click="$router.push({ path: '/education' })"
                aria-label="education"
                type="primary px-3 text-sm mt-4 w-full"
              >
                Get Started
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="px-2 md:px-0 py-16">
      <div class="container flex flex-wrap md:flex-no-wrap">
        <div class="flex">
          <div class="pr-md-5 m-auto flex flex-col items-center md:items-start">
            <div class="md:block flex flex-col justify-center md:items-start">
              <h2 class="text-xl font-semibold mb-1">For Employees</h2>
              <div class="h-1 w-6 rounded viva-blue mb-4"></div>
            </div>

            <h5 class="mb-5 text-center md:text-left mt-3">
              VIVA's loan programs and financial education resources help you to build credit, grow
              your savings, and achieve financial freedom.
            </h5>
            <router-link to="/welcome" class="py-2 rounded bg-primary">
              <span class="text-white btn base-button btn-primary px-3 text-sm mt-4 w-full"
                >Get Started</span
              >
            </router-link>
          </div>
        </div>
        <div>
          <div class="p-16">
            <img src="img/sketches/work.svg" alt="img" class="img-fluid md:pl-10" />
          </div>
        </div>
      </div>
    </section>

    <section class="px-2 md:px-0 py-5">
      <div class="container flex flex-wrap md:flex-no-wrap">
        <div>
          <div class="p-16">
            <img src="img/sketches/employers.svg" alt="img" class="img-fluid md:pr-10" />
          </div>
        </div>
        <div class="flex">
          <div class="pr-md-5 m-auto flex flex-col items-center md:items-start">
            <div class="md:block flex flex-col justify-center md:items-start">
              <h2 class="text-xl font-semibold mb-1">For Employers</h2>
              <div class="h-1 w-6 rounded viva-blue mb-4"></div>
            </div>

            <h5 class="mb-5 text-center md:text-left mt-3">
              Give your employees a benefit that will give you happier and more productive employees
              at no cost to your company.
            </h5>
            <router-link to="/employers" class="py-2 rounded bg-primary">
              <span class="text-white btn base-button btn-primary px-3 text-sm mt-4 w-full"
                >Get Started</span
              >
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="py-24 px-2 md:px-0 section-nucleo-icons text-center overflow-hidden viva-blue">
      <div class="text-4xl md:text-5xl mb-5 text-white">
        Building an inclusive financial system.
      </div>
      <div class="lead text-xl text-blue-200">VIVA Finance</div>
    </section>

    <section class="pt-24 pb-16 container">
      <h2 class="text-xl text-center mb-10">Our Founders</h2>
      <div class="flex flex-col md:flex-row justify-center pt-5">
        <div v-for="person in people" :key="person.link" class="md:px-8 my-3 md:my-0">
          <div class="flex mx-3">
            <img
              class="h-20 w-20 rounded-full hover:bg-blu-3 hover:bg-opacity-75"
              alt="img"
              :src="`img/misc/${person.picture}.png`"
            />
            <div class="flex-1 justify-center text-left pl-4">
              <h2 class="text-lg">{{ person.name }}</h2>
              <h5 class="text-gray-600">{{ person.position }}</h5>
              <a :href="`https://www.linkedin.com/in/${person.link}`"
                ><i
                  class="fab fa-linkedin text-lg text-blue-500 hover:text-secondary"
                  rel="noopener"
                  target="_blank"
                ></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="px-2 md:px-0 py-6">
      <div class="container">
        <div class="blur--hover card-shadow dashboard-card">
          <GoogleMaps />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import { Tooltip } from 'element-ui'
import Tooltip from 'element-ui/lib/tooltip'
import GoogleMaps from '@/views/Maps/GoogleMaps.vue'
import Vue from 'vue'
import Swal from 'sweetalert2'

export default {
  name: 'home-page',
  components: {
    [Tooltip.name]: Tooltip,
    GoogleMaps
  },
  data: function () {
    return {
      people: [
        {
          picture: 'jack',
          position: 'Co-Founder & Chief Executive Officer',
          name: 'Jack Markwalter',
          link: 'jack-markwalter-098b88b8/'
        },
        {
          picture: 'hodges',
          position: 'Co-Founder & Chief Operating Officer',
          name: 'Hodges Markwalter',
          link: 'hodges-markwalter-b46421102/'
        }
      ],
      close: false
    }
  },
  mounted() {
    const start = new Date('2022-07-01')
    const cutoff = new Date('2022-07-05')
    const now = new Date()
    if (start < now && now < cutoff) {
      Swal.fire({
        title: 'VIVA Finance Holiday Hours',
        confirmButtonColor: '#69D393',
        html:
          '<p class="mb-2">' +
          'Please note, VIVA will be closed on Monday, July 4<sup>th</sup>, 2022 in observance of Independence Day.' +
          '<p>We will resume processing applications on Tuesday, July 5<sup>th</sup>.</p>' +
          '</br>' +
          '<p>Sincerely,</p>' +
          '</br>' +
          '<p class="text-bold">The VIVA Team</p>',
        icon: 'info'
      })
    }
  },
  computed: {}
}
</script>
